import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { ControlLabel } from 'react-bootstrap'
import debounce from 'lodash/debounce'
import Select from 'react-select'
import Ipt from 'react-immutable-proptypes'

import { ClientRecord } from 'internal-components/src/records/Client'
import FormGroup from 'internal-components/src/components/Form/FormGroup'
import {
  makeSelectClientsForPartner,
  searchClients,
} from 'internal-components/src/redux/modules/client'

import SearchingSelector from './MspClientSelector/SearchingSelector'

export class MspClientSelector extends React.Component {
  state = {
    searchingValue: '',
  }

  handleSelect = (client, { action }) => {
    if (action === 'select-option') {
      this.props.selectClient(client.id)
    } else if (action === 'clear') {
      this.props.selectClient(null)
    }
  }

  search = debounce(searchingValue => {
    this.setState({
      searchingValue,
    })

    if (!searchingValue) {
      return
    }

    this.props.searchClients(searchingValue)
  }, 200)

  render() {
    const commonProps = {
      getOptionLabel: client => client.name,
      getOptionValue: client => client.id,
      isClearable: true,
      onChange: this.handleSelect,
      placeholder: 'Start typing to search...',
      value: this.props.selectedClientId,
    }

    const selector =
      this.props.clients === null ? (
        <SearchingSelector
          {...commonProps}
          noOptionsMessage={({ inputValue }) =>
            !inputValue
              ? 'Type to start searching'
              : `Your search for "${inputValue}" returned no results.`
          }
          onInputChange={inputValue => this.search(inputValue)}
          query={this.state.searchingValue}
          value={this.props.selectedClientId}
        />
      ) : (
        <Select
          {...commonProps}
          options={this.props.clients.toArray()}
          value={
            this.props.selectedClientId
              ? this.props.clients.find(
                  s => s.id === this.props.selectedClientId,
                )
              : null
          }
        />
      )

    return (
      <FormGroup controlId="clientSearch">
        <ControlLabel>Search for an existing Client</ControlLabel>

        {selector}
      </FormGroup>
    )
  }
}

MspClientSelector.propTypes = {
  // partner: Pt.instanceOf(PartnerRecord).isRequired,
  clients: Ipt.setOf(ClientRecord),
  searchClients: Pt.func.isRequired,
  selectClient: Pt.func.isRequired,
  selectedClientId: Pt.number,
}

export const makeMapStateToProps = () => {
  const selectClientsForPartner = makeSelectClientsForPartner()

  return (state, ownProps) => {
    const user = state.authentication.get('user')
    const isAdmin = user.roles.has('ROLE_SUPER_ADMIN')
    const clients = isAdmin
      ? null
      : selectClientsForPartner(state, {
          partner: ownProps.partner,
        })

    return {
      clients,
    }
  }
}

export default connect(
  makeMapStateToProps,
  { searchClients },
)(MspClientSelector)



// WEBPACK FOOTER //
// ./src/components/Signup/MspClientSelector.jsx